import { useCallback, useState } from 'react'

import { DismissableLayerProps } from '@radix-ui/react-dismissable-layer'

import { useObject } from 'data/hooks/objects'

import { useToast } from 'ui/components/Toast'

type UseManageDataTabRenamePopupStateProps = {
    objectSid: string
    onOpenChange: (open: boolean) => void
}

export function useManageDataTabRenamePopupState({
    objectSid,
    onOpenChange,
}: UseManageDataTabRenamePopupStateProps) {
    const onPointerDownOutside: DismissableLayerProps['onPointerDownOutside'] = useCallback((e) => {
        if (e.detail.originalEvent.defaultPrevented) {
            e.preventDefault()
        }
    }, [])

    const { object, changeObject } = useObject(objectSid)

    const [localName, setLocalName] = useState(object?.name)
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLocalName(e.target.value)
    }

    const toast = useToast()

    const onSave = async (
        e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>
    ) => {
        e.preventDefault()
        e.stopPropagation()

        if (!object) return

        try {
            await changeObject({ name: localName }, { allowOptimisticUpdates: true })
            onOpenChange(false)
        } catch (err) {
            console.error(err)
            toast({
                type: 'error',
                title: 'There was a problem renaming the table',
                startIcon: { name: 'AlertCircle' },
                helperText: 'Please try again later. If the issue persists, contact support.',
            })
        }
    }

    return {
        onPointerDownOutside,
        onChange,
        localName,
        onSave,
    }
}
